module.exports = __webpack_public_path__ + "img/bg_device_union.9230e130.svg";